import axios from "axios";
import { API_USERS_WATING_LIST } from "../init/urlApi";
import {
  WR_USERS_WAITING_FAIL,
  WR_USERS_WAITING_REQUEST,
  WR_USERS_WAITING_RESET,
  WR_USERS_WAITING_SUCCESS,
} from "../constants/usersWaitingRoomConstans";
import { userDataLocalStorage } from "../../../general/functions/base64Function";

export const RGetUsersWaiting = (data) => async (dispatch) => {
  dispatch({
    type: WR_USERS_WAITING_RESET,
  });
};

export const GetUsersWaiting = () => async (dispatch) => {
  const { token, session } = userDataLocalStorage();
  let d = session.split("-");
  let projectCode = [d[0], d[1]].join("-");
  let sessionId = d[2];

  try {
    dispatch({
      type: WR_USERS_WAITING_REQUEST,
    });

    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    const { data: data } = await axios.get(
      API_USERS_WATING_LIST(projectCode, sessionId),
      config
    );
    console.log("user wwaiting room", data);
    dispatch({
      type: WR_USERS_WAITING_SUCCESS,
      payload: data.data,
    });
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;

    dispatch({
      type: WR_USERS_WAITING_FAIL,
      payload: message,
    });
  }
};
